<template>
  <section class="content_container plan_confirm">
    <div class="thank_you text-center">
      <div class="img">
        <img :src="thankYouImage" width="45%" alt="Corenroll">
      </div>
      <div class="content mt-3">
        <!-- <h1>
          <span class="head_grey">Thank you for choosing our</span><br>Insurance Plans.
        </h1> -->
        <h2>Your {{isFromAetnaEnroll ? 'plan': 'plans'}} will be effective as of {{effective}}</h2>
        <div class="proceed-btn" v-if="!isFromAetnaEnroll">
          <button class="back me-0" type="button" id="backCart" name="button" @click="navigatePrevious">Back to Cart</button>
          <button class="proceed" type="button" id="beginEnroll" name="button" @click="nextPage">Proceed to Enrollment</button>
        </div>
        <div v-if="isFromAetnaEnroll">
          <button class="univ-btn" style="background: #006cb0;" @click="nextPage">Proceed to Enrollment</button>
          <button class="mt-3 univ-btn-transparent" @click="routeBackToAtenaFilter">Back</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import axios from 'axios';


import {checkAetnaDentalAccess} from "../utils/checkPlatform";
import {efTrack} from "../utils/EfTrack";

export default {
    name: "Confirmation",
    props:{
    effective: String,
    isFromAetnaEnroll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    landingInfo() {
      return this.$store.getters.getLandingInfo
    }
   },
    data: function () {
      return {
        tempId : window.localStorage.getItem('tempId'),
        thankYouImage: ''
      }
    },
    mounted() {
        let app = this;
        app.tempId = window.localStorage.getItem('tempId');
        app.fetchCatchInfo()
    },
    methods: {
        nextPage: function() {
          this.$emit('Checkoutcart');
          localStorage.setItem('enrollment','new_enrollment');
          this.$router.push('enrollment/personal-info');
          (this.checkAetnaDentalRedirection() && this.routeAthenaToEnrollment())
        },
        navigatePrevious: function() {
          this.$emit('hidePopUp');
        },
        fetchCatchInfo() {
          let siteDomain = window.btoa(unescape(encodeURIComponent(process.env.VUE_APP_SITE_DOMAIN)))
          // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
          let url = `${process.env.VUE_APP_API_BASE}/get-external-site-dynamic-information?site_domain=${siteDomain}`
          caches.open('fetch_color_cache').then((cache) => {
            cache.match(url).then(response => {
              response.json().then(data => {
                let getCatchColor = []
                let newObj = {}
                getCatchColor = data
                getCatchColor.map(item => {
                  newObj[item.key] = item.value;
                });
                this.thankYouImage = newObj["VUE_APP_THANK_YOU"]
              })
            })
          }).catch((err) => {
            console.log(err);
          })
        },
        routeBackToAtenaFilter () {
          let app = this
          app.$emit('routeBackToFilterEdit')
        },
        routeAthenaToEnrollment () {
          this.loadEverflowScript(22, 23)
          window.location.reload();
        },
        loadEverflowScript (offerId, eventId) {
          efTrack (offerId, eventId)
        },
        checkAetnaDentalRedirection () {
          let app = this
          return(checkAetnaDentalAccess(app.landingInfo))
        }
    }
}
</script>

<style scoped>

</style>
